import { Interface, Method } from '@central-products/transport-bus-common';
import { GetResponse, SetRequest, SetResponse } from './types';

@Interface('common', 'account.web.login.preferences')
export class WebLoginPreferencesInterface {
  @Method('get')
  public get(): Promise<GetResponse> {
    throw new Error('Method is not implemented yet');
  }

  @Method('set')
  // @ts-ignore
  public set(data: SetRequest): Promise<SetResponse> {
    throw new Error('Method is not implemented yet');
  }
}
